import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import userService from "../../../services/user.service";
// import { baseUrl } from "./config";

export const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [heading, setHeading] = useState({});
  const [count, setCount] = useState({
    coachCount: "",
    athleteCount: "",
    storage: "",
  });

  const testimonialDetails = [
    {
      size: "3K",
      title: "Teams",
    },
    {
      size: "33K",
      title: "Athletes",
    },
    {
      size: "1TB",
      title: "Storage",
    },
  ];
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // get testimonials
  useEffect(() => {
    getTestimonials();
    getCoachAthleteCount();
  }, []);

  const getTestimonials = () => {
    userService.getTestimonials().then((res) => {
      const testimonialData = res.data.data.testimonialsDetailsResponses;
      setTestimonials(testimonialData);
    });
  };

  const getCoachAthleteCount = () => {
    const data = userService.getCoachesAthleteCountForMainPage();
    data.then((res) => {
      const { athleteCount, schoolCount, coachCount } = res.data.data;
      setCount((old) => ({
        ...old,
        coachCount: coachCount,
        athleteCount: athleteCount,
        storage: schoolCount,
      }));
    });
  };

  // get heading
  useEffect(() => {
    getHeading();
  }, []);
  const getHeading = () => {
    userService.getTestimonialsHeading().then((res) => {
      const headingData = res.data.data[0];
      setHeading(headingData);
    });
  };

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        <div className="testimonial-container-items">
          <div>{count.coachCount}</div>
          <div>Coaches</div>
        </div>
        <div className="testimonial-container-items">
          <div>{count.athleteCount}</div>
          <div>Athletes</div>
        </div>
        <div className="testimonial-container-items">
          <div>{count.storage}</div>
          <div>Schools</div>
        </div>
      </div>
      <div className="testimonial-seprator" />
      <div className="testimonial-content">
        <div>{heading?.testimonialsHeading}</div>
        <div>{heading?.testimonialsDetails}</div>
      </div>

      <Slider {...settings}>
        {testimonials?.map((item, index) => (
          <div className="testimonial-tile-container pr-2">
            <div key={index} className="testimonial-tile">
              <div className="testimonial-tile-content">
                {item.content.slice(0, 180)}
              </div>
              <div className="testimonial-owner-content">
                <img alt="" src={item.uploadedLogo.filePath} />
                <div className="testimonial-created">
                  <div>{item.name}</div>
                  <div>Captian: {item.captian}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};
